module.exports = __webpack_public_path__ + "static/media/bg.027c20ba.png";